(() => {
  const timers = new WeakMap();
  function init(root=document) {
    root.querySelectorAll('[data-offer]').forEach(banner => {
      if (banner.dataset.ready) return;
      banner.dataset.ready='true';
      banner.querySelector('[data-close-offer]')?.addEventListener('click',()=>{banner.hidden=true;clearInterval(timers.get(banner));});
      banner.querySelector('[data-copy-code]')?.addEventListener('click',async event=>{
        const button=event.currentTarget,status=button.querySelector('[data-copy-status]');
        try{await navigator.clipboard.writeText(button.dataset.copyCode);status.textContent='Copié !';}
        catch{status.textContent='Sélectionne le code';const range=document.createRange();range.selectNodeContents(button.querySelector('b'));const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}
      });
      const value=banner.dataset.deadline;
      if (!value || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value)) return;
      const end=Date.parse(value);if(!Number.isFinite(end))return;
      const clock=banner.querySelector('[data-countdown]');
      const cells=['Jours','Heures','Minutes','Secondes'].map(label=>{const span=document.createElement('span'),b=document.createElement('b'),small=document.createElement('small');small.textContent=label;span.append(b,small);clock.append(span);return b;});
      const tick=()=>{const remaining=Math.max(0,Math.floor((end-Date.now())/1000));if(!remaining){banner.hidden=true;clearInterval(timers.get(banner));return;}clock.hidden=false;[Math.floor(remaining/86400),Math.floor(remaining/3600)%24,Math.floor(remaining/60)%60,remaining%60].forEach((n,i)=>cells[i].textContent=String(n).padStart(2,'0'));};
      tick();if(!banner.hidden)timers.set(banner,setInterval(tick,1000));
    });
  }
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-offer]').forEach(el=>clearInterval(timers.get(el))));
})();
